import { Component, OnInit, AfterViewInit } from '@angular/core';

declare var $;

@Component({
	selector: 'app-annotations',
	templateUrl: './annotations.component.html',
	styleUrls: ['./annotations.component.sass']
})
export class AnnotationsComponent implements OnInit, AfterViewInit {

	constructor() { }

	ngOnInit(): void {}

	ngAfterViewInit () :void {
		setTimeout(() => {
			$('.slider-grid').attr("disabled", true);
			$('.rotateInput').attr("disabled", true);
			$('.reset-grid-button').attr("disabled", true);
		}, 2000);

	}
}
